import type { ApolloCache } from "@apollo/client/cache"

import { add } from "shared/lib/arrayUtils"
import { ProjectTypename } from "shared/types/Project"
import { SpecialPriceGroup } from "shared/types/__generated__/graphql"

import {
  ProjectSpecialPriceGroupsFragment,
  ProjectSpecialPriceGroupsFragmentDoc
} from "entities/projects/graphql/fragments.generated"

export function insertSpecialPriceGroup({
  group,
  projectID,
  cache
}: {
  group: SpecialPriceGroup
  projectID: string
  cache: ApolloCache<object>
}) {
  const cacheId = cache.identify({ id: projectID, __typename: ProjectTypename })
  if (!cacheId) return
  cache.updateFragment<ProjectSpecialPriceGroupsFragment>(
    {
      id: cacheId,
      fragment: ProjectSpecialPriceGroupsFragmentDoc,
      fragmentName: "ProjectSpecialPriceGroups"
    },
    fragment => ({
      ...fragment,
      specialPriceGroups: add(group, fragment?.specialPriceGroups || []),
      __typename: ProjectTypename
    })
  )
}
